export default {"src":"/_next/static/media/LinkedinLight.2cf90768.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};